export const bankingingVals = [
  {
    "institution_id": 1,
    "name": "HDFC Bank",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "HDFC-FIP"
  },
  {
    "institution_id": 2,
    "name": "State Bank of India",
    "methods": ["PDF", "NB"],
    "fip-id": "sbi-fip"
  },
  {
    "institution_id": 3,
    "name": "ICICI Bank",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "ICICI-FIP"
  },
  {
    "institution_id": 4,
    "name": "Axis Bank",
    "methods": ["AA", "PDF"],
    "fip-id": "AXIS001"
  },
  {
    "institution_id": 5,
    "name": "Kotak Mahindra Bank",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "KotakMahindraBank-FIP"
  },
  {
    "institution_id": 7,
    "name": "IDBI Bank Ltd.",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "idbibank-fip"
  },
  {
    "institution_id": 8,
    "name": "Canara Bank",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "fiplive@canarabank"
  },
  {
    "institution_id": 9,
    "name": "Punjab National Bank",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "PNB-FIP"
  },
  {
    "institution_id": 10,
    "name": "Central Bank of India",
    "methods": ["AA", "PDF"],
    "fip-id": "CENTRALFIP"
  },
  {
    "institution_id": 11,
    "name": "Yes Bank Ltd",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "YESB-FIP"
  },
  {
    "institution_id": 12,
    "name": "Indian Bank",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "IBFIP"
  },
  {
    "institution_id": 13,
    "name": "Federal Bank",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "FDRLFIPPROD"
  },
  {
    "institution_id": 15,
    "name": "Bank Of India",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "BOI-FIP"
  },
  {
    "institution_id": 16,
    "name": "Union Bank Of India",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "UBI-FIP"
  },
  {
    "institution_id": 17,
    "name": "Bank of Baroda",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "BARBFIP"
  },
  {
    "institution_id": 19,
    "name": "Dena Bank",
    "methods": ["PDF", "NB"],
    "fip-id": ""
  },
  {
    "institution_id": 20,
    "name": "Vijaya Bank",
    "methods": ["PDF", "NB"],
    "fip-id": ""
  },
  {
    "institution_id": 21,
    "name": "Corporation Bank",
    "methods": ["PDF", "NB"],
    "fip-id": ""
  },
  {
    "institution_id": 22,
    "name": "Oriental Bank of Commerce",
    "methods": ["PDF", "NB"],
    "fip-id": ""
  },
  {
    "institution_id": 23,
    "name": "United Bank of India",
    "methods": ["PDF", "NB"],
    "fip-id": ""
  },
  {
    "institution_id": 24,
    "name": "Syndicate Bank",
    "methods": ["PDF", "NB"],
    "fip-id": ""
  },
  {
    "institution_id": 25,
    "name": "Standard Chartered Bank",
    "methods": ["PDF", "NB"],
    "fip-id": ""
  },
  {
    "institution_id": 26,
    "name": "IndusInd Bank Ltd.",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "fiplive@indusind"
  },
  {
    "institution_id": 27,
    "name": "Allahabad Bank",
    "methods": ["PDF", "NB"],
    "fip-id": ""
  },
  {
    "institution_id": 28,
    "name": "Karnataka Bank Ltd",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "KBL-FIP"
  },
  {
    "institution_id": 29,
    "name": "IDFC FIRST BANK",
    "methods": ["AA", "PDF"],
    "fip-id": "IDFCFirstBank-FIP"
  },
  {
    "institution_id": 30,
    "name": "Indian Overseas Bank",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "IOB-FIP"
  },
  {
    "institution_id": 31,
    "name": "Paytm Payments Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 32,
    "name": "Karur Vysya Bank",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "KarurVysyaBank-FIP"
  },
  {
    "institution_id": 33,
    "name": "Ujjivan Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 34,
    "name": "UCO Bank",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "UCOB-FIP"
  },
  {
    "institution_id": 35,
    "name": "South Indian Bank",
    "methods": ["AA", "PDF"],
    "fip-id": "SIBLFIP"
  },
  {
    "institution_id": 36,
    "name": "RBL Bank Limited",
    "methods": ["AA", "PDF", "NB"],
    "fip-id": "rblbank-fip"
  },
  {
    "institution_id": 37,
    "name": "Fino Payments Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 38,
    "name": "Bank of Maharashtra",
    "methods": ["AA", "PDF"],
    "fip-id": "BOM_FIP"
  },
  {
    "institution_id": 39,
    "name": "AUBank",
    "methods": ["AA", "PDF"],
    "fip-id": "AUBank-FIP"
  },
  {
    "institution_id": 40,
    "name": "Punjab and Sind Bank",
    "methods": ["AA"],
    "fip-id": "PSFIP"
  },
  {
    "institution_id": 41,
    "name": "Fincare Small Finance Bank",
    "methods": ["AA", "PDF"],
    "fip-id": "fiplive@fincarebank"
  },
  {
    "institution_id": 42,
    "name": "DBS Bank India Limited",
    "methods": ["PDF", "NB"],
    "fip-id": ""
  },
  {
    "institution_id": 43,
    "name": "Bandhan Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 44,
    "name": "Municipal Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 45,
    "name": "Utkarsh Small Finance Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 46,
    "name": "Jana Small Finance Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 47,
    "name": "Esaf Small Finance Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 48,
    "name": "Equitas Small Finance Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 49,
    "name": "CITY UNION BANK LTD",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 50,
    "name": "India Post Payments Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 51,
    "name": "DCB Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },

//   {
//     "institution_id": 52,
//     "name": "Kfin Technologies Limited (Mutual Fund)",
//     "methods": ["AA"],
//     "fip-id": "kfinmf-fip"
//   },
//   {
//     "institution_id": 53,
//     "name": "National Securities Depository Limited",
//     "methods": ["AA"],
//     "fip-id": "fip@nsdl"
//   },
//   {
//     "institution_id": 54,
//     "name": "Central Depository Services Limited",
//     "methods": ["AA"],
//     "fip-id": "CDSLFIP"
//   },
//   {
//     "institution_id": 55,
//     "name": "Goods and Services Tax Network",
//     "methods": ["AA"],
//     "fip-id": "GSTN-FIP"
//   },
//   {
//     "institution_id": 56,
//     "name": "Aviva India Life Insurance",
//     "methods": [],
//     "fip-id": ""
//   },
//   {
//     "institution_id": 57,
//     "name": "Bajaj Allianz Life Insurance Co. Ltd.",
//     "methods": ["AA"],
//     "fip-id": "balic-fip"
//   },
//   {
//     "institution_id": 58,
//     "name": "Canara HSBC Life Insurance Co. Ltd.",
//     "methods": ["AA"],
//     "fip-id": "chli-fip"
//   },
//   {
//     "institution_id": 59,
//     "name": "HDFC Life Insurance",
//     "methods": ["AA"],
//     "fip-id": "fiplive@hdfclife"
//   },
//   {
//     "institution_id": 60,
//     "name": "ICICI Prudential Life Insurance",
//     "methods": ["AA"],
//     "fip-id": "iciciprudential-fip"
//   },
//   {
//     "institution_id": 61,
//     "name": "Max Life Insurance Co. Ltd.",
//     "methods": ["AA"],
//     "fip-id": "maxlifeinsurance-fip"
//   },
//   {
//     "institution_id": 62,
//     "name": "Pramerica Life Insurance Limited",
//     "methods": [],
//     "fip-id": ""
//   },
//   {
//     "institution_id": 63,
//     "name": "PNB MetLife Insurance Limited",
//     "methods": ["AA"],
//     "fip-id": "pnbmetlife-fip"
//   },
//   {
//     "institution_id": 64,
//     "name": "Raheja QBE General Insurance Company Limited",
//     "methods": [],
//     "fip-id": ""
//   },
//   {
//     "institution_id": 65,
//     "name": "SBI Life Insurance Co. Ltd.",
//     "methods": ["AA"],
//     "fip-id": "sbilife-fip"
//   },
//   {
//     "institution_id": 66,
//     "name": "Tata AIA Life Insurance",
//     "methods": ["AA"],
//     "fip-id": "talic-fip"
//   },
//   {
//     "institution_id": 67,
//     "name": "HDFC Ergo General Insurance",
//     "methods": ["AA"],
//     "fip-id": "hegi-fip"
//   },
//   {
//     "institution_id": 68,
//     "name": "Bharati Axa Life Insurance Company",
//     "methods": [],
//     "fip-id": ""
//   },
//   {
//     "institution_id": 69,
//     "name": "Saraswat co-operative Bank Ltd",
//     "methods": ["PDF"],
//     "fip-id": ""
//   },
  {
    "institution_id": 70,
    "name": "Airtel Payments Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 71,
    "name": "Tamilnad Mercentile Bank Ltd.",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 72,
    "name": "Rajasthan Marudhara Gramin Bank",
    "methods": ["AA", "PDF"],
    "fip-id": "rmgbrrb-fip"
  },
  {
    "institution_id": 73,
    "name": "Abhyudaya Co-Operative Bank Ltd",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 74,
    "name": "Jammu&Kashmir Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 75,
    "name": "Karnataka Vikas Grameena Bank",
    "methods": ["AA", "PDF"],
    "fip-id": "kvgbank-fip"
  },
  {
    "institution_id": 76,
    "name": "AP GRAMEENA VIKAS BANK",
    "methods": ["AA", "PDF"],
    "fip-id": "apgvb-fip"
  },
  {
    "institution_id": 77,
    "name": "Punjab and Sind Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 78,
    "name": "Thane Janata Sahakari Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 79,
    "name": "The Cosmos Co-op. Bank Ltd",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 80,
    "name": "CSB Bank Ltd.",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 81,
    "name": "GP Parsik Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 82,
    "name": "Dhanlaxmi Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 83,
    "name": "Shamrao Vithal Co-op. Bank Ltd.",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 84,
    "name": "Telangana State Co-operative Apex Bank Ltd.",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 85,
    "name": "Janata Sahakari Bank Ltd.",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 86,
    "name": "Kalyan Janata Sahakari Bank Ltd.",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 87,
    "name": "kallapana awade Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 88,
    "name": "Sarva Haryana Gramin Bank",
    "methods": ["AA", "PDF"],
    "fip-id": "SHGB-FIP"
  },
  {
    "institution_id": 89,
    "name": "Post Office Saving Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 90,
    "name": "Sarvodaya Commercial Co-Operactive Bank Limited",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 91,
    "name": "NKGSB Bank",
    "methods": ["PDF"],
    "fip-id": ""
  },
  {
    "institution_id": 92,
    "name": "HSBC",
    "methods": ["AA", "PDF"],
    "fip-id": "HSBC-FIP"
  },
  {
    "institution_id": 93,
    "name": "ACME BANK",
    "methods": [],
    "fip-id": ""
  },
  {
    "institution_id": 94,
    "name": "FinShareBankServer",
    "methods": [],
    "fip-id": ""
  },
  {
    "institution_id": 95,
    "name": "Setu FIP",
    "methods": [],
    "fip-id": ""
  },
  {
    "institution_id": 96,
    "name": "Finvu Bank Ltd",
    "methods": [],
    "fip-id": ""
  },
  {
    "institution_id": 97,
    "name": "Finvu GSTN",
    "methods": [],
    "fip-id": ""
  }
].sort((a, b) => a.name.localeCompare(b.name));
